module.exports = __webpack_public_path__ + "media/images/emblems/Villorsonnens-coat_of_arms-601d28d84150e0c6aed9db95582e2f88.svg";